var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoffbord201(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 152 130.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:#fff;}.cls-2{clip-path:url(#clip-path);}.cls-3{stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "-27.66 135.83 173.76 135.83 173.76 2.75 -27.66 2.75 -27.66 135.83"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "42.93 12.8 31.2 15.98 22.23 23.24 17.01 34.07 12.72 62.21 12.96 75.89 14.64 85.58 23.34 100.67 39.78 112.46 51.03 115.82 64.71 117.11 98.43 117.11 114.03 115.25 127.17 112.04 135.57 105.95 139.29 96.32 137.88 84.47 133.95 72.98 121.23 53.45 112.11 43.76 103.89 36.29 91.98 27.92 87.12 24.74 76.68 19.34 69.03 16.73 54.12 12.8 42.93 12.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "44.04 15.41 32.84 18.46 24.35 25.39 19.38 35.7 15.3 62.58 15.54 75.67 17.11 84.91 25.39 99.31 41.03 110.58 51.72 113.78 64.73 115.04 96.84 115.04 111.67 113.25 124.18 110.17 132.16 104.37 135.7 95.16 134.36 83.86 130.61 72.89 118.52 54.24 109.85 44.97 102.05 37.86 90.67 29.84 86.06 26.8 76.14 21.66 68.87 19.14 54.67 15.41 44.04 15.41"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoffbord201);
export default __webpack_public_path__ + "static/media/soffbord 2-01.27d1d5c95af535e246dec4b85531fb1a.svg";
export { ForwardRef as ReactComponent };